<template>
  <div class="floor" @click="handleClick">
    <portal-target
      :key="destination"
      v-show="(floor.state !== 'fight' && floor.state !== 'fail') || bonus"
      class="floor__gg-wrapper"
      :name="destination"
    />

    <Animation
      v-show="floor.state === 'fight' && !bonus"
      :play="floor.state === 'fight'"
      :loop="false"
      @complete="stopFight"
      animation="fight"
    />

    <img
      v-show="floor.state === 'win'"
      src="../../assets/img/tower/shield.svg"
      class="floor__win"
    />

    <Character
      v-show="floor.state === 'init' || floor.state === 'lose' || bonus"
      :character="character"
      class="floor__enemy"
      :class="{ 'floor__enemy--hide': floor.state === 'win' && bonus }"
    />

    <portal to="modal">
      <div v-if="isMobile && descriptionShowed" class="modal modal__opened">
        <div
          class="modal__scrollbox modal__scrollbox_closable"
          @click.stop.self="descriptionShowed = false"
        >
          <div class="modal__inner">
            <div class="modal__close" @click.stop="descriptionShowed = false" />
            <CharacterDescription
              @submit="move"
              :character="character.character"
            />
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import range from "lodash/range";

import Animation from "../Animation";
import Character from "../Character";
import CharacterDescription from "../CharacterDescription";

export default {
  components: { Character, Animation, CharacterDescription },
  props: ["towerId", "floor", "floorId"],
  data() {
    return {
      descriptionShowed: false
    };
  },
  computed: {
    ...mapState(["player", "levelId", "isMobile"]),
    ...mapGetters(["level"]),
    bonus() {
      return this.floor.character === "littlebigplanet";
    },
    destination() {
      return `${this.towerId}:${this.floorId}`;
    },
    character() {
      return {
        character: this.floor.character,
        power: this.floor.power
      };
    }
  },
  methods: {
    stopFight() {
      this.$store.commit("player/setState", { state: "none" });

      const win = this.floor.power < this.player.power;

      this.$store.commit("updateFloorState", {
        towerId: this.towerId,
        floorId: this.floorId,
        state: win ? "win" : "fail"
      });

      const haveMoves = range(this.towerId - 1, this.towerId + 2).some(
        towerId => {
          const tower = this.level.towers[towerId];
          if (!tower) return false;

          return tower.some(floor => floor.state !== "win");
        }
      );

      if (!win) {
        this.$store.commit("failLevel");
        this.$store.commit("toggleModal", "levelFail");
        return;
      }

      // update player power
      const power = this.player.hasBonus
        ? this.player.power / 2
        : this.player.power;
      this.$store.commit("player/setPower", {
        power: this.floor.effect(power),
        hasBonus: this.bonus
      });

      const completed = this.level.check(this.level, this.player);
      const missClicker =
        this.levelId === 2 &&
        this.level.towers.reduce(
          (acc, tower) =>
            acc + tower.filter(floor => floor.state === "win").length,
          0
        ) >= 5 &&
        !completed;

      if ((!haveMoves && !completed) || missClicker) {
        this.$events.emit("playSound", "gameover");
        this.$store.commit("failLevel");
        this.$store.commit("toggleModal", "levelFail");
        return;
      }

      switch (this.floor.character) {
        case "darksouls":
          this.$events.emit("playSound", "king");
          break;
        case "thelastofus":
          this.$events.emit("playSound", "clicker");
          break;
        default:
          this.$events.emit("playSound", "lvlup");
      }

      if (completed) {
        this.$store.commit("finishLevel");
        return setTimeout(
          () => this.$store.commit("toggleModal", "levelFinish"),
          1000
        );
      }
    },
    handleClick() {
      if (this.isMobile) {
        this.descriptionShowed = true;
      } else {
        this.move();
      }
    },
    move() {
      this.descriptionShowed = false;
      const nearTower = Math.abs(this.towerId - this.player.towerId) <= 1;
      if (
        this.level.state === "finish" ||
        this.floor.state !== "init" ||
        this.player.state !== "none" ||
        !nearTower
      )
        return;

      this.$store.dispatch("player/move", {
        towerId: this.towerId,
        floorId: this.floorId,
        floor: this.floor
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.floor {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: 8%;
  position: relative;

  cursor: pointer;

  background: url(../../assets/img/tower/window.svg) center center / contain
    no-repeat;

  &__enemy {
    height: 80% !important;
    transition: opacity 0.25s ease;

    &--hide {
      opacity: 0;
    }
  }

  &__gg-wrapper {
    left: 5%;
    z-index: 1;
    position: absolute;
  }

  &__win {
    height: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    transform: translate(-50%, -50%);
  }
}
</style>
